// Thrid-party
import React from 'react';

// Components
import { CancelButton, PrimaryButton, SecondaryButton } from '../../../buttons';

// Types
import { FileUploaderSteps } from './FileUploaderFlow';

// Utils
import { formatMessage } from '@/utils/i18n';

export type Props = {
  currentStep: FileUploaderSteps;
  onCancel: () => void;
  onImport: () => void;
  onUpload: () => void;
  onDownload: () => void;
  onContinue: () => void;
};

const FileUploaderActions: React.FC<Props> = ({ onCancel, currentStep, onImport, onUpload, onDownload, onContinue }) => (
  <div className="file-uploader-actions">
    <CancelButton onClick={onCancel} />

    <div className="d-flex">
      {currentStep !== FileUploaderSteps.UPLOAD && <SecondaryButton onClick={onUpload}>{formatMessage('Modal.PortfolioUpload.UpdateFile')}</SecondaryButton>}
      {currentStep === FileUploaderSteps.DEFINE_HEADERS ? (
        <PrimaryButton className="ms-3" onClick={onContinue}>
          {formatMessage('Common.Continue')}
        </PrimaryButton>
      ) : (
        <PrimaryButton className="ms-3" disabled={currentStep !== FileUploaderSteps.IMPORT} onClick={onImport}>
          {currentStep === FileUploaderSteps.IMPORT ? formatMessage('Modal.PortfolioUpload.Import') : formatMessage('Common.Continue')}
        </PrimaryButton>
      )}
    </div>
  </div>
);

export default FileUploaderActions;
